import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.freeze.js";

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";

/*
 *  Cart Subscription Widget
 *    Scripts for the cart subscribe
 *
 *  Version:
 *    1.0.0 - 2021/05/10
 */
import { LineItem } from '../../tools/cart/line-item';
import { html, unsafeTranslate, useEffect, useState, virtual } from '../../tools/utilities/component';
import { cartAdd, getCart } from '@process-creative/slate-theme-tools';
import { CartState } from './cart-drawer-component';
import { SellingPlanPriceAdjustment } from '../../tools/cart/selling-plan';

// Util functions
var removeItemByKey = function removeItemByKey(key) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  });
};
/**
 * Extracts the current subscription information from a given line item.
 * @param lineItem Line item to extract the information from.
 * @returns Information about what state the line item's subscription is in.
 */


var subscriptionFromLine = function subscriptionFromLine(lineItem) {
  var selling_plan_allocation = lineItem.selling_plan_allocation,
      properties = lineItem.properties;
  var planOptions = properties && properties._selling_plans ? JSON.parse(properties._selling_plans) : [];
  var planId = selling_plan_allocation && selling_plan_allocation.selling_plan ? selling_plan_allocation.selling_plan.id : null;
  var planEnabled = planId !== null;
  /**
   * We will try and get the price adjustments from the line properties with the
   * matching plan id. If there is no matching plan we will use the price adjustments
   * from the first plan since the discount should be done on a product level anyway
   */

  var linePropertiesSellingPlans = null;

  if (lineItem.properties && lineItem.properties['_selling_plans']) {
    linePropertiesSellingPlans = JSON.parse(lineItem.properties['_selling_plans']);
  }

  var SellingPlanWithPriceAdjustments = linePropertiesSellingPlans ? linePropertiesSellingPlans.find(function (plan) {
    return plan.id === planId;
  }) : null;
  SellingPlanWithPriceAdjustments = SellingPlanWithPriceAdjustments ? SellingPlanWithPriceAdjustments : linePropertiesSellingPlans ? linePropertiesSellingPlans[0] : null;
  var planPriceAdjustments = SellingPlanWithPriceAdjustments ? SellingPlanWithPriceAdjustments.price_adjustments : null;
  return {
    planOptions: planOptions,
    planEnabled: planEnabled,
    planId: planId,
    planPriceAdjustments: planPriceAdjustments
  };
};

export var CartSubscriptionWidgetCreate = virtual(function (params) {
  var cartState = params.cartState,
      index = params.index; // Initialize the default state.

  var lineItem = cartState.cart.items[index];
  var lineSub = subscriptionFromLine(lineItem);

  var _useState = useState(lineSub.planOptions),
      _useState2 = _slicedToArray(_useState, 2),
      planOptions = _useState2[0],
      setPlanOptions = _useState2[1];

  var _useState3 = useState(lineSub.planId),
      _useState4 = _slicedToArray(_useState3, 2),
      userPlanId = _useState4[0],
      setUserPlanId = _useState4[1];

  var _useState5 = useState(lineSub.planEnabled),
      _useState6 = _slicedToArray(_useState5, 2),
      userPlanEnabled = _useState6[0],
      setUserPlanEnabled = _useState6[1];

  var _useState7 = useState(lineSub.planPriceAdjustments),
      _useState8 = _slicedToArray(_useState7, 2),
      planPriceAdjustments = _useState8[0],
      setPlanPriceAdjustments = _useState8[1]; // Every time the cart updates, fix the states to be corrected.


  useEffect(function () {
    setPlanOptions(lineSub.planOptions);
    setUserPlanId(lineSub.planId);
    setUserPlanEnabled(lineSub.planEnabled);
    setPlanPriceAdjustments(lineSub.planPriceAdjustments);
  }, [cartState.cart]); // If no plan options, don't render

  if (!planOptions.length) return null; // Method that will update the subscription

  var updateSubscription = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(enabled) {
      var plan, item;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              plan = null;

              if (enabled) {
                plan = userPlanId;
                if (!plan) plan = lineSub.planId;
                if (!plan) plan = planOptions[0].id;
              }

              item = _objectSpread({}, lineItem);
              _context.next = 5;
              return removeItemByKey(item.key);

            case 5:
              _context.next = 7;
              return cartAdd({
                items: [{
                  id: item.variant_id,
                  quantity: item.quantity,
                  selling_plan: plan ? plan : undefined,
                  properties: item.properties
                }]
              });

            case 7:
              _context.next = 9;
              return getCart();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateSubscription(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // On change of values, update cart.


  useEffect(function () {
    if (!lineSub.planEnabled) return;
    if (userPlanId === lineSub.planId) return;
    updateSubscription(userPlanEnabled);
  }, [userPlanId]);
  useEffect(function () {
    if (userPlanEnabled === lineSub.planEnabled) return;
    updateSubscription(userPlanEnabled);
  }, [userPlanEnabled]);
  /**
   * Assign price adjustment string. If there are no price adjustments then we
   * will use a translation that does not use the discount variable
   */

  var subscriptionDiscount = planPriceAdjustments && planPriceAdjustments[0] && planPriceAdjustments[0].value > 0 ? unsafeTranslate('products.product.subscription_cart', {
    'discount': planPriceAdjustments[0].value.toString()
  }) : unsafeTranslate('products.product.subscription_cart_no_discount'); // Render widget

  return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    <div class=\"c-cart-line__subscription ", "\">\n      <div class=\"c-cart-line__subscription-row\">\n        <div class=\"c-cart-line__subscription-row-inner\">\n          <input type=\"checkbox\"\n            class=\"c-cart-line__subscription-checkbox u-visually-hidden\"\n            id=\"subscribe-checkbox-", "\"\n            .checked=", " ?disabled=", "\n            @change=", "\n          />\n          <label class=\"c-cart-line__subscription-checkbox-label o-paragraph-2\"\n            for=\"subscribe-checkbox-", "\"\n          >\n            ", "\n          </label>\n        </div>\n      </div>\n\n      <div class=\"c-cart-line__subscription-row c-cart-line__subscription-row-expander\">\n        <div class=\"c-cart-line__subscription-row-inner\">\n          <label class=\"u-visually-hidden\" for=\"subscribe-select-", "\">\n            ", "\n          </label>\n\n          <select id=\"subscribe-select-", "\" ?disabled=", "\n            class=\"c-cart-line__subscription-select o-paragraph-2\"\n            @change=", "\n          >\n            ", "\n          </select>\n        </div>\n      </div>\n\n    </div>\n  "])), userPlanEnabled ? 'is-expanded' : '', params.index, userPlanEnabled, cartState.pending, function () {
    return setUserPlanEnabled(!userPlanEnabled);
  }, params.index, subscriptionDiscount, params.index, unsafeTranslate('general.cart.subscription_accessibility_select'), params.index, cartState.pending, function (e) {
    setUserPlanId(parseInt(e.target.value));
  }, planOptions.map(function (option) {
    var name = option.name,
        id = option.id;
    return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<option value=", " .selected=", ">", "</option>"])), id, id === userPlanId, name);
  }));
});